import React from "react";

/**
 * Step indicator for org and individual signup wizards.
 *
 * @param {Object} props
 * @param {{ label: string, number: number }[]} props.steps
 * @param {number} props.currentStep
 * @returns {JSX.Element}
 */
export default function ProgressTabs({ steps, currentStep }) {
  const getStepStatus = (stepIndex) => {
    if (stepIndex < currentStep) return "completed";
    if (stepIndex === currentStep) return "current";
    return "pending";
  };

  return (
    <div className="mb-8">
      <div className="relative flex items-start justify-evenly">
        {steps.map((step, index) => {
          if (index === steps.length - 1) return null;
          const prevStatus = getStepStatus(index);
          const isCompleted = prevStatus === "completed";
          const startPercent = (index + 0.5) * (100 / steps.length);
          const endPercent = (index + 1.5) * (100 / steps.length);
          const width = endPercent - startPercent;

          return (
            <div
              key={`line-${index}`}
              className={`absolute h-0.5 ${isCompleted ? "bg-accent" : "bg-border"}`}
              style={{
                left: `${startPercent}%`,
                width: `${width}%`,
                top: "20px",
              }}
            />
          );
        })}

        {steps.map((step, index) => {
          const status = getStepStatus(index);
          return (
            <div key={index} className="relative z-10 flex flex-1 flex-col items-center">
              <div
                className={`
                                flex h-10 w-10 items-center justify-center rounded-full font-semibold
                                ${
                                  status === "completed"
                                    ? "bg-accent text-text-on-accent"
                                    : status === "current"
                                      ? "bg-accent text-text-on-accent ring-2 ring-accent ring-offset-2 ring-offset-primary"
                                      : "border-2 border-border bg-secondary text-text-secondary"
                                }
                            `}
              >
                {status === "completed" ? "✓" : step.number}
              </div>
              <span
                className={`
                                mt-2 text-center text-sm font-medium
                                ${
                                  status === "completed" || status === "current"
                                    ? "text-text-primary"
                                    : "text-text-secondary"
                                }
                            `}
              >
                {step.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
